import { useState } from "react";
import { Slider } from "@/components/ui/slider";
import exteriorTour from "@/assets/family-white-home.mp4.asset.json";

const SavingsCalculator = () => {
  const [price, setPrice] = useState(400000);
  const sellerSavesLow = Math.round(price * 0.03);
  const sellerSavesHigh = Math.round(price * 0.06);
  const buyerSaves = Math.round(price * 0.03);

  const fmt = (n: number) => "$" + n.toLocaleString();

  return (
    <section className="relative bg-secondary py-20 px-6 overflow-hidden">
      {/* Background luxury exterior tour video */}
      <video
        src={exteriorTour.url}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Subtle directional gradient — darker behind card/text, fading to clear on the right */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/35 via-black/15 to-transparent" />
      {/* Soft vertical edge falloff for legibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/10" />

      <div className="relative z-10 max-w-[960px] mx-auto">
        <p className="text-xs font-bold uppercase tracking-widest mb-3 text-primary-foreground">
          Your savings calculator
        </p>
        <h2
          className="text-3xl md:text-4xl font-bold mb-3 text-destructive-foreground"
          style={{ lineHeight: '1.2', letterSpacing: '-0.5px' }}
        >
          See exactly what stays in your pocket
        </h2>
        <p className="text-base leading-relaxed max-w-[560px] mb-10 text-secondary">
          Move the slider to your home's price. The math is simple — and it's yours.
        </p>

        <div className="bg-card rounded-2xl p-7 border border-primary/30 max-w-[600px] mb-4 shadow-xl">
          <p className="text-sm font-medium text-primary mb-3">Home price</p>
          <div className="flex items-center gap-4 mb-6">
            <Slider
              value={[price]}
              onValueChange={([v]) => setPrice(v)}
              min={100000}
              max={2000000}
              step={10000}
              className="flex-1"
              aria-label="Home price"
            />
            <span className="text-xl md:text-2xl font-bold text-secondary-foreground min-w-[120px] text-right tabular-nums">
              {fmt(price)}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="bg-secondary rounded-xl p-4 text-center">
              <div className="text-2xl md:text-3xl font-bold text-secondary-foreground tabular-nums">
                {fmt(sellerSavesLow)}–{fmt(sellerSavesHigh)}
              </div>
              <div className="text-xs font-medium text-primary mt-1">
                Seller saves (3–6%)
              </div>
            </div>
            <div className="bg-brand-amber-50 rounded-xl p-4 text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-foreground tabular-nums">
                {fmt(buyerSaves)}
              </div>
              <div className="text-xs font-medium text-accent-foreground/80 mt-1">
                Buyer can negotiate (3%)
              </div>
            </div>
          </div>
        </div>

        <p className="text-xs text-secondary">
          Based on the traditional 3–6% total commission. REALV3 platform fee applies — see pricing page.
        </p>
      </div>
    </section>
  );
};

export default SavingsCalculator;
